import React from 'react';

const NotFoundPage = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-white">404 - Page Not Found</h1>
      <p className='text-white'>The page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFoundPage